export default __webpack_public_path__ + "static/scores@2x-ea4014a761d34baad8288cf616714186.png";